import { Card, Col, Flex, Input, Row, Typography } from 'antd';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// components
import PageTitle from 'components/title/title';
import StatusComponent from 'components/status/status';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import DisabledElement from 'components/disabledElement/disabledElement';
import BackButton from 'components/backButton/backButton';
import { Notice } from '../models/notice';
import { useNavigate, useParams } from 'react-router-dom';
import NotificationService from 'core/services/notification';
import { onGetNoticeById } from '../services/noticeService';

// services

// styles

// models

interface NoticeViewPageProps {}

const NoticeViewPage: FunctionComponent<NoticeViewPageProps> = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const { id } = useParams<{ id: string }>();

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [notice, setNotice] = useState<Notice>();

	useEffect(() => {
		getNoticeDetails();
	}, []);

	const getNoticeDetails = async () => {
		try {
			setIsLoading(true);

			const response = await onGetNoticeById(id as string);

			setNotice(response);
			setIsLoading(false);
		} catch (error) {
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.FETCH_ERROR'));
			navigate('/dashboard/actions/notice');
		}
	};

	return (
		<>
			<PageTitle name={t('TITLE.ACTIONS')} />

			<BackButton />

			{isLoading ? (
				<LoadingComponent />
			) : (
				<Card className="mt-3">
					<Row gutter={[16, 16]}>
						<Col span={24}>
							<Flex align="center" gap={20}>
								<h5 className="mb-0">{notice?.request_number}</h5>
								<StatusComponent text={t('COMMON.SENT')} color="green" small />
							</Flex>
							<p className="text-light">{notice?.created_at}</p>
						</Col>

						<Col span={24} md={12}>
							<DisabledElement label={t('ACTIONS.SHAREHOLDER_NAME')} value={notice?.notifiable.name} />
						</Col>

						<Col span={24} md={12}>
							<DisabledElement label={t('COMMON.NATIONAL_ID')} value={notice?.notifiable.national_id} />
						</Col>

						<Col span={24}>
							<Typography style={{ fontSize: 15, marginBottom: 5 }}>{t('ACTIONS.MESSAGE')}</Typography>
							<Input.TextArea rows={5} style={{ resize: 'none', color: '#000' }} disabled value={notice?.message} />
						</Col>
					</Row>
				</Card>
			)}
		</>
	);
};

export default NoticeViewPage;
